import { createSlice } from '@reduxjs/toolkit';
import { getUserInfo, logout as logoutAuth } from '../../auth/authProvider';
import type { AppDispatch } from '../index';

interface UserInfo {
  accountIdentifier?: string;
  name?: string;
  sid?: string;
  userName?: string;
  jwtIdToken?: string;
  [key: string]: any;
}

export interface AuthState {
  user: UserInfo | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state) => {
      const accountInfo = getUserInfo();

      if (!accountInfo) {
        state.user = null;
        state.isAuthenticated = false;
        return;
      }
      state.user = {
        accountIdentifier: accountInfo.homeAccountId,
        name: accountInfo.name,
        userName: accountInfo.username,
        sid: accountInfo.localAccountId,
        jwtIdToken: accountInfo.idToken,
      };
      state.isAuthenticated = true;
    },
    clearAuth: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
  },
});

export const { setUser, clearAuth } = authSlice.actions;

// Thunk action to handle logout orchestration
export const logout = () => async (dispatch: AppDispatch) => {
  await logoutAuth();
  dispatch(clearAuth());
};

export default authSlice.reducer;
